import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Reaksi dasar kurang kerjaan putar putar.
        </p>
        <a
          className="App-link"
          href="https://irawan.io"
          target="_blank"
          rel="noopener noreferrer"
        >
          Websiteku
        </a>
      </header>
    </div>
  );
}

export default App;
